import React, { } from "react";
import Slider from "react-slick";
import "./brands-in-spotlight.scss";

const BrandsInSpotlight = ({ brandImages = [], navigate }) => {
  let ExcitingSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 9,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 812,
        settings: {
          slidesToShow: brandImages?.length > 3 ? 3 : brandImages?.length,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          initialSlide: 0.5,
          slidesToScroll: 1,
          slidesToShow: 3.6,
        },
      },
    ],
  };

  const handleImageClick = async (data) => {
    if (data?.providerId) {
      try {
        const encodedValue = encodeURIComponent(data?.providerId);
        navigate(`seller?pid=${encodedValue}`);
      } catch (error) { }
    }
  };

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <Slider {...ExcitingSettings} className="brands-in-spotlight-slider-kl">
              {brandImages.map((brand, index) => (
                <div onClick={() => {
                  handleImageClick(brand);
                }} className="brands-in-spotlight-items-kl" key={index}>
                  <div className="brands-in-spotlight-items-img-kl">
                    <img src={brand?.value ?? ""} alt={`Exciting offer ${index + 1}`} />
                  </div>
                  <div className="spotlight-name-kl">
                    {brand?.providerName ?? ""}
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default BrandsInSpotlight;
